import { render, staticRenderFns } from "./OfflineBanner.vue?vue&type=template&id=784aef10&scoped=true&"
import script from "./OfflineBanner.vue?vue&type=script&lang=js&"
export * from "./OfflineBanner.vue?vue&type=script&lang=js&"
import style0 from "./OfflineBanner.vue?vue&type=style&index=0&id=784aef10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784aef10",
  null
  
)

export default component.exports